import ResultsIntellectualProperty from './resultsIntellectualProperty.js';
export default ResultsIntellectualProperty;
